var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BoostPortalPaymentStatusHelper, PaymentStatus } from '../helpers/BoostPortalPaymentStatusHelper';
import { BoostPortalNavigationSteps } from '../enums/BoostPortalNavigationSteps';
import { TrackingEvent } from '../tracking/TrackingEvent';
export class BoostNavigationController {
    constructor(host, vippsPaymentController) {
        host.addController(this);
        this.vippsPaymentController = vippsPaymentController;
        this.host = host;
    }
    hostConnected() {
        //
    }
    updateCurrentStep(step) {
        this.vippsPaymentController.setCurrentStep(step);
        this.host.requestUpdate();
    }
    updateTrackingEvent(event) {
        this.vippsPaymentController.setTrackerCompletedEvent(event);
        this.host.requestUpdate();
    }
    onCallbackChange() {
        return __awaiter(this, void 0, void 0, function* () {
            const isInvoicePaid = yield this.vippsPaymentController.isInvoicePaid();
            if (this.vippsPaymentController.isCallbackNets) {
                if (this.vippsPaymentController.isNetsStatusFailed) {
                    this.updateCurrentStep(BoostPortalNavigationSteps.DIRECTDEBIT);
                    this.updateTrackingEvent(TrackingEvent.AvtalegiroSigningFailed);
                }
                else if (this.vippsPaymentController.shouldGoToPaymentStepDirectDebit) {
                    this.updateCurrentStep(BoostPortalNavigationSteps.PAYMENT);
                }
                else if (isInvoicePaid) {
                    this.updateCurrentStep(BoostPortalNavigationSteps.SUCCESS);
                    this.updateTrackingEvent(TrackingEvent.AvtalegiroSigningCompleted);
                }
                this.updateCurrentStep(BoostPortalNavigationSteps.PAYMENT);
                this.host.requestUpdate();
            }
            if (this.vippsPaymentController.isCallbackVipps) {
                const invoiceId = this.vippsPaymentController.getInvoiceId();
                const paymentStatus = yield BoostPortalPaymentStatusHelper.getPaymentStatus(invoiceId);
                if (paymentStatus === PaymentStatus.PAYMENTSUCCESS) {
                    this.updateCurrentStep(BoostPortalNavigationSteps.SUCCESS);
                }
                else {
                    this.updateCurrentStep(BoostPortalNavigationSteps.PAYMENT);
                }
                return;
            }
        });
    }
}
